import {HomeMeasurementStatus} from "../../../list/found-measurement";
import {MeasurementType} from "../../../measurement-models";

export function isFinishMeasuringButtonDisabled(homeStatus: HomeMeasurementStatus, startTime: string | undefined, measurementType: MeasurementType) {
  return !(homeStatus === "MAILED_TO_PATIENT" && (startTime !== undefined || measurementType === "SLEEP"));
}
